import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import FeatureOfTheWeekCard from "components/common/FeatureOfTheWeekCard/FeatureOfTheWeekCard";
import { URL_PUBLIC_FEATURE_OF_THE_WEEK } from "store/services/URL";
import vertex360DarkMark from "assets/auth/vertex360-wordmark-dark.png";

/**
 * Public marketing page — no login required. Uses the unauthenticated API.
 */
const FeatureOfTheWeekLanding = () => {
  const [feature, setFeature] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(URL_PUBLIC_FEATURE_OF_THE_WEEK);
        if (!cancelled) {
          setFeature(response?.data?.data?.feature_of_the_week ?? null);
        }
      } catch (err) {
        if (!cancelled) {
          setError(
            err?.response?.data?.message ||
              err?.message ||
              "Unable to load Feature of the Week."
          );
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className='min-h-screen bg-gradient-to-b from-indigo-50/80 via-white to-gray-50 px-4 py-10'>
      <div className='mx-auto flex max-w-3xl flex-col items-center gap-8'>
        <header className='flex w-full flex-col items-center gap-4 text-center sm:flex-row sm:justify-between sm:text-left'>
          <img
            src={vertex360DarkMark}
            alt='Vertex360'
            className='h-8 w-auto'
          />
          <Link
            to='/'
            className='text-sm font-medium text-indigo-600 hover:text-indigo-800'
          >
            Sign in to Vertex360
          </Link>
        </header>

        {loading ? (
          <CircularLoader
            classes='flex justify-center py-16'
            classloader='loader-l'
          />
        ) : error ? (
          <p className='rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700'>
            {error}
          </p>
        ) : (
          <FeatureOfTheWeekCard
            title={feature?.title || "Feature of the Week"}
            description={feature?.description || ""}
            videoUrl={feature?.video_url || ""}
            embedUrl={feature?.embed_url || null}
            emptyMessage='No feature is published right now. Check back soon.'
            className='w-full shadow-md'
          />
        )}
      </div>
    </div>
  );
};

export default FeatureOfTheWeekLanding;
